import { useEffect } from 'react';

export default function VerificationComplete() {
  useEffect(() => {
    window.close();
  }, []);

  return null;
}
